<script>
  import { csv } from 'd3-fetch';
  import CityServicesText from './CityServicesText.svelte';
  import { __ } from '../../../utils/i18n'

  export let city; // just name of the place
  export let isCity;


  const serviceURL = window.DATA_URLS.city_services

  // see if the city is in the spreadsheet
  async function serviceLookup(c) {
    const data = await csv(serviceURL);
    let found = data.find((item) => String(item.id) == String(c));
    // console.log('popo', found, Object(found).dept_name);
    return Object(found);
  }

  $: service = isCity==true ? serviceLookup(city) : serviceLookup('Unincorporated')

  let showAll = false;
  function onToggle() {
    showAll = !showAll;
  }

</script>

<div class="icard block slim" class:show-more={showAll}>
  <div class="header">
    <h3>🏘 <span>{__("Need something fixed on your block?")}</span> 
      {#if city !== "Unincorporated"}
        {__("Access city services")}
        {:else}
        {__("Access county services")}
      {/if}</h3>
    <button on:click={onToggle}>{showAll ? '-' : '+'}</button>
  </div>

  <div>
    {#await service}
      <p />
    {:then p}
      <CityServicesText d={p} {isCity}/>
    {:catch error}
      <p style="color: red">{error.message}</p>
    {/await}
  </div>
</div>
